(function(){
  if (window.__swyftHeader) return; window.__swyftHeader = true;
  function setCountry(cc){
    var f=document.getElementById('swl-form'); if(!f) return;
    f.querySelector('[name=country_code]').value=cc; f.submit();
  }
  function wirePill(root){
    var pill=root.querySelector('.swl-pill'), dd=root.querySelector('.swl-dd');
    pill.addEventListener('click',function(e){e.stopPropagation();var o=dd.hidden;document.querySelectorAll('.swl-dd').forEach(function(d){d.hidden=true});document.querySelectorAll('.swl-pill').forEach(function(p){p.setAttribute('aria-expanded','false')});dd.hidden=!o;pill.setAttribute('aria-expanded',o?'true':'false');});
    root.querySelectorAll('.swl-opt').forEach(function(b){b.addEventListener('click',function(){setCountry(b.dataset.cc)})});
  }
  function init(){
    var src=document.getElementById('swl-src'); var hc=document.getElementById('header-component'); if(!src||!hc) return;
    var cols=hc.querySelector('.header__row--top .header__columns'); if(!cols) return;
    // pastille mobile (dans la grille, à droite de MENU)
    if(!cols.querySelector('.swl--m')){var m=src.querySelector('.swl').cloneNode(true);m.classList.add('swl--m');cols.appendChild(m);wirePill(m);}
    // pastille ordinateur (colonne de droite, avant Recherche)
    var right=cols.querySelector('.header__column--right');
    if(right&&!right.querySelector('.swl--d')){var d=src.querySelector('.swl').cloneNode(true);d.classList.add('swl--d');right.insertBefore(d,right.firstChild);wirePill(d);}
    // lien Compte (remplace le bouton de compte Shopify)
    var ab=hc.querySelector('.account-button');
    if(ab&&!ab.querySelector('.swa')){var a=document.createElement('a');a.className='swa';a.href='/account';a.textContent='Compte';ab.appendChild(a);}
    // contenu du menu mobile
    hc.querySelectorAll('.menu-drawer').forEach(function(md){
      var nav=md.querySelector('.menu-drawer__navigation'); if(!nav||md.querySelector('.swm-search')) return;
      nav.parentNode.insertBefore(src.querySelector('.swm-extra-top').cloneNode(true),nav);
      var bot=src.querySelector('.swm-extra-bottom').cloneNode(true); nav.parentNode.insertBefore(bot,nav.nextSibling);
      bot.querySelectorAll('.swm-cc').forEach(function(b){b.addEventListener('click',function(){setCountry(b.dataset.cc)})});
    });
    var det=hc.querySelector('#Details-menu-drawer-container');
    if(det){ var sync=function(){document.documentElement.classList.toggle('swm-open',det.hasAttribute('open'))}; det.addEventListener('toggle',sync); new MutationObserver(sync).observe(det,{attributes:true,attributeFilter:['open']}); }
  }
  document.addEventListener('click',function(){document.querySelectorAll('.swl-dd').forEach(function(d){d.hidden=true});document.querySelectorAll('.swl-pill').forEach(function(p){p.setAttribute('aria-expanded','false')});});
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  setTimeout(init,800);
})();
